import React, { Component } from 'react';
import { Box } from '@mui/material';
import SectionTitle from './SectionTitle';
import DeletableNumericInput from '../../../../../components/DeletableNumericInput';
import { ALERT_SEVERITY } from '../../../../../components/AlertDisplay2';

const DELETED_KEYS = {
    perUserLimit: 'perUserLimitDeleted',
    perShopUserLimit: 'perShopUserLimitDeleted',
    perShopLimit: 'perShopLimitDeleted',
    globalCapQty: 'globalCapQtyDeleted',
};

class CapConfigSection extends Component {
    setMyValue(key, value) {
        const { editMode, setValue, showAlert } = this.props;

        if (editMode && !Object.values(DELETED_KEYS).includes(key)) {
            showAlert?.('Die Daten können nicht bearbeitet werden.', ALERT_SEVERITY.WARNING);
            return;
        }

        if (Object.values(DELETED_KEYS).includes(key)) {
            setValue?.(key, value);
            return;
        }

        const numericValue = value != null && !isNaN(Number(value)) ? parseInt(value, 10) : null;
        setValue?.(key, numericValue);
    }

    onFocus() {
        if (this.props.editMode) {
            this.props.showAlert?.('Die Daten können nicht bearbeitet werden.', ALERT_SEVERITY.WARNING);
        }
    }

    setDeleted(flagKey, value, realKey) {
        if (this.props.editMode) {
            this.setMyValue(flagKey, value);
        } else {
            this.setMyValue(realKey, value ? null : this.props[realKey]?.toString() ?? '');
        }
    }

    render() {
        const {
            perUserLimit,
            perShopUserLimit,
            perShopLimit,
            globalCapQty,
            perUserLimitDeleted,
            perShopUserLimitDeleted,
            perShopLimitDeleted,
            globalCapQtyDeleted,
            showAlert,
        } = this.props;

        const labelWidth = 220;

        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                <SectionTitle
                    icon={require('../../../../../assets/icons/box.png')}
                    label="Mengenkonfiguration"
                />

                <DeletableNumericInput
                    maxLength={2}
                    onFocus={() => this.onFocus()}
                    value={perUserLimit}
                    setValue={(val) => {
                        const numericVal = val != null && !isNaN(Number(val)) ? parseInt(val, 10) : null;

                        if (numericVal != null && this.props.globalCapQty != null && this.props.globalCapQty <= numericVal) {
                            showAlert?.('Das Limit pro Benutzer darf die globale Obergrenze nicht erreichen oder überschreiten.', ALERT_SEVERITY.WARNING);
                            return;
                        }

                        this.setMyValue('perUserLimit', val);
                    }}
                    setDeleted={(val) => {
                        this.setDeleted(DELETED_KEYS.perUserLimit, val, 'perUserLimit');
                    }}
                    placeholder="Limit pro Benutzer"
                    labelAreaWidth={labelWidth}
                    disabled={this.props.editMode}
                    deleted={perUserLimitDeleted}
                    nullable
                />

                <DeletableNumericInput
                    maxLength={2}
                    onFocus={() => this.onFocus()}
                    value={perShopUserLimit}
                    setValue={(val) => {
                        const numericVal = val != null && !isNaN(Number(val)) ? parseInt(val, 10) : null;

                        if (numericVal != null && this.props.globalCapQty != null && this.props.globalCapQty <= numericVal) {
                            showAlert?.('Das Limit pro Benutzer und Shop darf die globale Obergrenze nicht erreichen oder überschreiten.', ALERT_SEVERITY.WARNING);
                            return;
                        }

                        this.setMyValue('perShopUserLimit', val);
                    }}
                    setDeleted={(val) => {
                        this.setDeleted(DELETED_KEYS.perShopUserLimit, val, 'perShopUserLimit');
                    }}
                    placeholder="Limit pro Benutzer und Shop"
                    labelAreaWidth={labelWidth}
                    disabled={this.props.editMode}
                    deleted={perShopUserLimitDeleted}
                    nullable
                />

                <DeletableNumericInput
                    maxLength={4}
                    onFocus={() => this.onFocus()}
                    value={perShopLimit}
                    setValue={(val) => {
                        const numericVal = val != null && !isNaN(Number(val)) ? parseInt(val, 10) : null;

                        if (numericVal != null && this.props.globalCapQty != null && this.props.globalCapQty <= numericVal) {
                            showAlert?.('Das Limit pro Shop darf die globale Obergrenze nicht erreichen oder überschreiten.', ALERT_SEVERITY.WARNING);
                            return;
                        }

                        this.setMyValue('perShopLimit', val);
                    }}
                    setDeleted={(val) => {
                        this.setDeleted(DELETED_KEYS.perShopLimit, val, 'perShopLimit');
                    }}
                    placeholder="Limit pro Shop"
                    labelAreaWidth={labelWidth}
                    disabled={this.props.editMode}
                    deleted={perShopLimitDeleted}
                    nullable
                />

                <DeletableNumericInput
                    maxLength={6}
                    onFocus={() => this.onFocus()}
                    value={globalCapQty}
                    setValue={(val) => {
                        this.setMyValue('globalCapQty', val);
                    }}
                    onEndEditing={(val) => {
                        const numericVal = val != null && !isNaN(Number(val)) ? parseInt(val, 10) : null;

                        if (numericVal != null) {
                            if (this.props.perUserLimit != null && numericVal < this.props.perUserLimit) {
                                this.setMyValue('perUserLimit', null);
                                showAlert?.('Das Limit pro Benutzer überschreitet die globale Obergrenze.', ALERT_SEVERITY.WARNING);
                            }

                            if (this.props.perShopUserLimit != null && numericVal < this.props.perShopUserLimit) {
                                this.setMyValue('perShopUserLimit', null);
                                showAlert?.('Das Limit pro Benutzer und Shop überschreitet die globale Obergrenze.', ALERT_SEVERITY.WARNING);
                            }

                            if (this.props.perShopLimit != null && numericVal < this.props.perShopLimit) {
                                this.setMyValue('perShopLimit', null);
                                showAlert?.('Das Limit pro Shop überschreitet die globale Obergrenze.', ALERT_SEVERITY.WARNING);
                            }
                        }
                    }}
                    setDeleted={(val) => {
                        this.setDeleted(DELETED_KEYS.globalCapQty, val, 'globalCapQty');
                    }}
                    placeholder="Globale Obergrenze"
                    labelAreaWidth={labelWidth}
                    disabled={this.props.editMode}
                    deleted={globalCapQtyDeleted}
                    nullable
                />
            </Box>
        );
    }
}

export default CapConfigSection;